import { cxoneSdkState } from '../state';

export function setPendingInboundContactId(contactId: string | null): void {
  cxoneSdkState.pendingInboundContactId = contactId;
}

export function getPendingInboundContactId(): string | null {
  return cxoneSdkState.pendingInboundContactId;
}

export function clearPendingInboundContactId(): void {
  cxoneSdkState.pendingInboundContactId = null;
}
